import BaseClass from "./BaseClass";

const defaultOptions = {};

/**
 * Initialise the lazyloading of images.
 */
export default class Lazyloading extends BaseClass {

  constructor(options) {
      super(options, defaultOptions);

      const config = {
        rootMargin: '0px 0px 50px 0px',
        threshold: 0
      };

      this.observer = new IntersectionObserver((entries, self) => {
        // Iterate over each entry
        entries.forEach(entry => {
          // Process just the images that are intersecting.
          // isIntersecting is a property exposed by the interface
          if(entry.isIntersecting) {
            this.loadImage(entry.target);

            // The image is now in place, stop watching
            self.unobserve(entry.target);
          }
        });
      }, config);

      this.init();
  }

  /**
   * Fills in the observer.
   */
  init() {
    $(document).ready(() => {
      this.appendToObserver(document);
    });
  }

  /**
   * Appends lazy images under parent to a observer.
   *
   * @param {Element} parent
   */
  appendToObserver(parent) {
    $(parent).find('[data-lazy]').each((index, element) => {
      this.observer.observe(element);
    });
  }

  /**
   * Loads the image.
   * * Use after the image is visible.
   *
   * @param {Element} element
   */
  loadImage(element) {
    let $element = $(element);

    if($element.is('img')) {
      $element.attr('src', $element.data('lazy'));
    } else {
      $element.attr('style', 'background-image: url(' + $element.data('lazy') + ')');
    }
  }
}
